"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _undraw_website_setup_5hr = require("../data/undraw_website_setup_5hr2.svg");

var _undraw_website_setup_5hr2 = _interopRequireDefault(_undraw_website_setup_5hr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    "div",
    { id: "fc-checkout-completion" },
    _react2.default.createElement("img", { src: _undraw_website_setup_5hr2.default, alt: "complete" })
  );
};